import SearchOverlay from './SearchOverlayRedux';

export default SearchOverlay;
